import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import "../styles.scss";

export const videogameFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <path
        d="M60.4618 92.7824V90.0993H34.5382V95.284H51.7867C53.2495 93.5009 55.5124 92.3749 58.0648 92.4041C58.8978 92.4137 59.7029 92.5457 60.4618 92.7824Z"
        fill={frameColor}
      />
      <path
        d="M51.3439 95.8802C50.7279 96.7998 50.3083 97.858 50.1414 99H25.0122V97.755C25.0122 96.7194 25.851 95.8802 26.8862 95.8802H51.3439Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.5223 36H79.4777C80.3184 36 81 36.6819 81 37.523V87.9937C81 88.8347 80.3184 89.5167 79.4777 89.5167H15.5223C14.6816 89.5167 14 88.8347 14 87.9937V37.523C14 36.6819 14.6816 36 15.5223 36ZM17.1236 86.3917H77.8768V39.1246H17.1236V86.3917Z"
        fill={frameColor}
      />
      <path
        d="M81.7683 102.031C81.0448 102.023 80.4516 101.459 80.4434 100.772C80.4351 100.085 81.0148 99.5342 81.7383 99.5422C82.4616 99.5503 83.0547 100.114 83.063 100.801C83.0712 101.488 82.4915 102.039 81.7683 102.031ZM78.7903 99.201C78.0668 99.1929 77.4737 98.6293 77.4654 97.942C77.4571 97.2546 78.0368 96.7044 78.7604 96.7124C79.4836 96.7205 80.0767 97.2838 80.085 97.9711C80.0933 98.6585 79.5135 99.209 78.7903 99.201ZM78.8577 104.795C78.1341 104.787 77.541 104.223 77.5327 103.536C77.5245 102.849 78.1042 102.298 78.8277 102.306C79.5509 102.314 80.1441 102.878 80.1523 103.565C80.1606 104.253 79.5809 104.803 78.8577 104.795ZM75.8797 101.965C75.1562 101.957 74.563 101.394 74.5548 100.706C74.5465 100.019 75.1262 99.4686 75.8498 99.4766C76.573 99.4847 77.1661 100.048 77.1744 100.735C77.1827 101.423 76.6029 101.973 75.8797 101.965ZM73.5811 109.837C72.0726 109.82 70.836 108.645 70.8187 107.212C70.8015 105.779 72.0102 104.631 73.5186 104.648C75.0271 104.665 76.2638 105.84 76.281 107.273C76.2983 108.706 75.0895 109.854 73.5811 109.837ZM67.8484 102.816C66.8425 102.805 66.0174 102.021 66.0059 101.066C65.9944 100.11 66.8009 99.3441 67.8067 99.3553C68.8129 99.3666 69.6376 100.151 69.6491 101.106C69.6606 102.062 68.8545 102.828 67.8484 102.816ZM64.7551 107.67C64.7568 107.812 64.6367 107.926 64.4871 107.924L62.319 107.9L62.3438 109.96C62.3455 110.102 62.2257 110.216 62.0761 110.214L60.9244 110.201C60.7746 110.2 60.652 110.083 60.6503 109.941L60.6255 107.881L58.4574 107.857C58.3078 107.855 58.1852 107.739 58.1835 107.597L58.1703 106.503C58.1686 106.36 58.2884 106.247 58.438 106.248L60.6061 106.272L60.5813 104.213C60.5796 104.071 60.6994 103.957 60.8493 103.959L62.001 103.971C62.1505 103.973 62.2731 104.09 62.2748 104.232L62.2996 106.291L64.4677 106.316C64.6173 106.317 64.7402 106.434 64.7419 106.576L64.7551 107.67ZM62.644 109.87L62.6238 108.19L64.3936 108.21C64.0816 108.972 63.4467 109.574 62.644 109.87ZM60.3536 109.858C59.5255 109.549 58.86 108.926 58.5241 108.145L60.3332 108.165L60.3536 109.858ZM60.2861 104.252L60.307 105.989L58.4814 105.968C58.7918 105.174 59.45 104.548 60.2861 104.252ZM54.0293 100.205C54.0099 98.5961 55.3671 97.3071 57.0607 97.326C58.7539 97.3449 60.1425 98.6644 60.1619 100.273C60.1812 101.882 58.824 103.171 57.1308 103.152C55.4373 103.133 54.0487 101.813 54.0293 100.205ZM62.5768 104.292C63.4019 104.611 64.0598 105.245 64.384 106.034L62.5976 106.014L62.5768 104.292ZM85.9782 113.717C85.5537 110.206 85.5523 110.192 84.4672 101.221C84.0259 97.3222 80.5348 94.2383 76.3314 94.1915C74.6942 94.1732 73.1764 94.6187 71.9127 95.3987C69.0703 96.6299 66.5152 96.6014 63.6426 95.3065C62.3596 94.4981 60.8306 94.0188 59.1934 94.0005C54.99 93.9537 51.5723 96.9606 51.2247 100.851C50.3554 109.8 50.3543 109.814 50.0141 113.316C50.0039 113.42 49.9989 113.525 50.0002 113.632C50.0202 115.29 51.451 116.65 53.1959 116.669C54.0345 116.678 54.7926 116.376 55.3523 115.876C57.2517 114.178 57.8072 113.683 60.4075 111.358C65.7097 109.819 70.1942 109.869 75.535 111.527C78.1919 113.91 78.7589 114.418 80.6996 116.158C81.2716 116.671 82.0378 116.99 82.8763 117C84.6212 117.019 86.0197 115.691 85.9998 114.033C85.9985 113.927 85.991 113.821 85.9782 113.717Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17 86.2672H77.7533V39H17V86.2672Z"
        fill={frameBackgroundColor}
      />
      <foreignObject
        width="48%"
        height="46px"
        style={{ borderRadius: "3px" }}
        x="25"
        y="40">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",

            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="15">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
